(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hair-benefits-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hair-benefits-tabs')) {
    customElements.define('hair-benefits-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const initialize = () => {
          this.tabs = Array.from(this.querySelectorAll('[data-hb-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-hb-panel]'));
          this.nav = this.querySelector('[data-hb-nav]');
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index), options);
            tab.addEventListener('keydown', event => {
              let next = index;
              const rtl = getComputedStyle(this.nav).direction === 'rtl';
              if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
              else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
              else if (event.key === 'Home') next = 0;
              else if (event.key === 'End') next = this.tabs.length - 1;
              else return;
              event.preventDefault();
              next = (next + this.tabs.length) % this.tabs.length;
              this.select(next, true);
            }, options);
          });
          document.addEventListener('shopify:block:select', event => {
            const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
            if (index >= 0) this.select(index);
          }, options);
          const selectedIndex = this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
          if (selectedIndex >= 0) this.select(selectedIndex);
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { ...options, once: true });
        else initialize();
      }
      select(index, focus = false) {
        if (!this.tabs[index]) return;
        this.tabs.forEach((tab, position) => {
          const selected = position === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[position].hidden = !selected;
        });
        const tab = this.tabs[index];
        if (focus) tab.focus({ preventScroll: true });
        if (this.nav.scrollWidth > this.nav.clientWidth) {
          const bounds = tab.getBoundingClientRect();
          const navBounds = this.nav.getBoundingClientRect();
          const offset = bounds.left - navBounds.left - (navBounds.width - bounds.width) / 2;
          this.nav.scrollBy({ left: offset, behavior: 'instant' });
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scalp-serum-results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scalp-proof-section')) {
    customElements.define('scalp-proof-section', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const initialize = () => {
          this.track = this.querySelector('[data-sp-track]');
          this.slides = Array.from(this.querySelectorAll('[data-sp-slide]'));
          this.status = this.querySelector('[data-sp-status]');
          if (!this.track || !this.slides.length) return;
          this.index = 0;
          this.querySelectorAll('[data-sp-prev], [data-sp-next]').forEach(button => {
            button.hidden = false;
            button.addEventListener('click', () => this.go(this.index + (button.hasAttribute('data-sp-next') ? 1 : -1)), options);
          });
          this.track.addEventListener('scroll', () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => {
              this.index = Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
              this.update();
            });
          }, { ...options, passive: true });
          this.track.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            if (event.key === 'Home') this.go(0);
            else if (event.key === 'End') this.go(this.slides.length - 1);
            else this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }, options);
          document.addEventListener('shopify:block:select', event => {
            const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
            if (index >= 0) this.go(index, true);
          }, options);
          this.resizeObserver = new ResizeObserver(() => this.go(this.index, true));
          this.resizeObserver.observe(this.track);
          this.update();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { ...options, once: true });
        else initialize();
      }
      go(index, immediate = false) {
        const count = this.slides.length;
        this.index = (index + count) % count;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: immediate || reduced ? 'instant' : 'smooth' });
        this.update();
      }
      update() {
        if (this.status) this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
